<template>
  <b-card no-body>
    <b-card-header class="border-bottom mb-2">
      <b-card-title>
        <div>En Çok Ziyaret Edilenler</div>
        <b-card-sub-title style="margin-top: 1px">
          İlk 10 Bağlantı
        </b-card-sub-title>
      </b-card-title>
    </b-card-header>
    <template v-if="dataList.length > 0">
      <b-card-body>
        <b-list-group>
          <b-list-group-item
            v-for="item in dataList"
            :key="item.id"
          >
            <div class="d-flex justify-content-between align-items-center">
              <div class="font-weight-bold">
                {{ item.title }}
              </div>
              <div>
                <b-badge
                  pill
                  variant="light-info"
                  class="mr-1"
                >
                  {{ item.singular | toNumber }}
                </b-badge>
                <b-badge
                  pill
                  variant="light-info"
                >
                  {{ item.plural | toNumber }}
                </b-badge>
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-card-body>
      <b-card-footer class="text-center">
        <div>
          <b-badge
            pill
            variant="light-info"
            class="mr-1"
          >
            Tekil Görüntüleme
          </b-badge>
          <b-badge
            pill
            variant="light-info"
          >
            Toplam Görüntüleme
          </b-badge>
        </div>
      </b-card-footer>
    </template>
    <b-card-body v-else>
      <b-alert
        variant="info"
        show
      >
        <div class="alert-body text-center">
          Raporlama için veri bulunmuyor.
        </div>
      </b-alert>
    </b-card-body>
  </b-card>
</template>
<script>
import {
  BCard, BListGroup, BListGroupItem, BBadge, BCardHeader, BCardTitle, BCardSubTitle, BCardBody,
  BCardFooter, BAlert,
} from 'bootstrap-vue'

export default {
  name: 'QrVisitsCard',
  components: {
    BAlert,
    BCard,
    BListGroup,
    BListGroupItem,
    BBadge,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    BCardBody,
    BCardFooter,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
  },
}
</script>
